import { getErrorDetail } from 'components/utility/utils';
import { fetchOrchidAPI } from 'utils/api';

export interface rolesData {
  role_name: string;
}

export default async function addRoles (
  teamId: string,
  roleData: rolesData,
): Promise<void> {
  const res = await fetchOrchidAPI(
    `/api/users/v1/team/${teamId}/roles/add?role_name=${encodeURIComponent(
      roleData.role_name,
    )}`,
    {
      method: 'POST',
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
}
